<template>
  <v-row>
    <v-col cols="11" md="5">
      <v-row>
        <v-col cols="12">
          <div class="card ml-5 pa-6">
            <!-- show center name and description -->

            <div v-if="!editDescription.open">
              <p class="text-h6">
                {{ info.centro }}
                <span @click="handleEditDescription" class="edit-des"
                  ><v-icon> mdi-pencil </v-icon></span
                >
              </p>
              <p v-if="info.description == ''">
                Não há mensagem cadastrada.
              </p>
              <p>{{ info.description }}</p>
            </div>

            <!-- edit description -->
            <div v-if="editDescription.open" class="mt-6">
              <v-text-field
                v-model="editDescription.placeholder"
                label="Nova Mensagem"
                maxlength="280"
                :rules="[
                  editDescription.rules.required,
                  editDescription.rules.counter
                ]"
                counter
                outlined
              ></v-text-field>
              <div>
                <v-icon
                  @click="editDescription.open = false"
                  class="ma-2"
                >
                  mdi-arrow-left
                </v-icon>
                <v-icon @click="saveEditDescription" class="c-b ma-2">
                  mdi-checkbox-marked-circle
                </v-icon>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <div
            v-if="!editDescription.open"
            class="card ml-5 pt-3 pl-3"
          >
            <a :href="link" target="_blank" class="link">
              {{ link }}</a
            >
            <v-icon
              class="ml-3 mb-1 cursor"
              v-clipboard:copy="link"
              @click="copyURL"
            >
              mdi-content-copy
            </v-icon>
            <v-icon v-if="copy" class="ml-n4 mb-1 check">
              mdi-check-bold
            </v-icon>
          </div>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="5" md="3">
      <div class="card ml-5 py-6 qr">
        <div>
          <qrcode-vue
            :value="link"
            :size="142"
            level="H"
          ></qrcode-vue>
        </div>
      </div>
    </v-col>

    <!-- DISPLAY PRINT BUTTON -->
    <v-col cols="12" md="4" class="pr-11">
      <v-row>
        <v-col cols="12" class="cursor" @click="generateReport">
          <div class="card ml-5 pa-5">
            <v-row>
              <v-col cols="1">
                <v-icon class="mb-1 icon">
                  mdi-printer
                </v-icon>
              </v-col>
              <v-col cols="11">
                <p class="text-button">
                  Imprimir Identificação de Salas
                </p>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <!-- DISPLAY DELETE BUTTON -->
        <v-col cols="6" class="pt-0 cursor">
          <div class="card ml-5 pa-8-5">
            <v-switch
              v-model="toggle"
              @change="HandleTaggle"
              class="mt-n1"
              :label="
                info.status == 'published'
                  ? 'Alocação pública'
                  : 'Alocação indisponível'
              "
              color="primary"
              hide-details
            ></v-switch>
          </div>
        </v-col>

        <!-- DISPLAY EDIT BUTTON -->
        <v-col cols="3" class="pt-0 cursor">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="card ml-5 pa-8-5"
                @click="openEdit"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class="icon pb-2">
                  mdi-square-edit-outline
                </v-icon>
              </div>
            </template>
            <span>Edição da Alocação</span>
          </v-tooltip>
        </v-col>

        <v-col cols="3" class="pt-0 cursor">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="card ml-5 pa-8-5"
                @click="openHistory"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class="icon pb-2">
                  mdi-history
                </v-icon>
              </div>
            </template>
            <span>Histórico de Alocações</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import {
  editDescriptionPaasCenter,
  toggleStatusPaasCenter
} from "@/api/paas/center";

export default {
  name: "EditCenter",
  props: {
    info: Object
  },
  data() {
    return {
      dialog: {
        open: false,
        title: "",
        msg: "",
        clicked: ""
      },
      copy: false,
      toggle: false,
      edit: {
        show: false
      },
      editDescription: {
        open: false,
        placeholder: "",
        rules: {
          required: value => !!value || "Digite algo.",
          counter: value =>
            value.length <= 280 || "Max 280 caracteres"
        }
      }
    };
  },
  computed: {
    link() {
      return origin + `${this.info.link}`
    }
  },
  components: {
    QrcodeVue
  },
  mounted() {
    this.toggle = this.info.status == "published";
  },
  methods: {
    openEdit() {
      this.$emit("edit");
    },
    openHistory() {
      this.$emit("history");
    },
    HandleTaggle(e) {
      this.info.status = e ? "published" : "not-published";
      this.$emit("toggleStatus");
      toggleStatusPaasCenter().catch(() => {
        this.info.status = !e ? "published" : "not-published";
        this.toggle = !e;
        this.$emit("toggleStatus");
        alert("Erro ao mudar disponibilidade da alocação");
      });
    },
    generateReport() {
      const routeData = this.$router.resolve({
        path: "/print-rooms"
      });
      window.open(routeData.href, "_blank");
    },
    copyURL() {
      this.copy = true;
      setTimeout(() => {
        this.copy = false;
      }, 3000);
    },
    handleEditDescription() {
      this.editDescription.placeholder = this.info.description;
      this.editDescription.open = true;
    },
    async saveEditDescription() {
      if (this.editDescription.placeholder.length <= 280) {
        await editDescriptionPaasCenter(
          this.editDescription.placeholder
        );
        this.info.description = this.editDescription.placeholder;
        this.editDescription.open = false;
      }
    }
  }
};
</script>

<style scoped>
.title {
  margin-left: 15px;
  color: white;
}

.card {
  border-radius: 15px;
  background-color: white;
  width: 100%;
  min-height: 50px;
}

.qr {
  text-align: center;
}

.link {
  text-decoration: none;
}

.c-b {
  color: #1565c0;
}

.icon {
  font-size: 30px;
  color: #1565c0;
}

.pa-8-5 {
  padding: 26px 34px;
}
.cursor {
  cursor: pointer;
}

.check {
  color: green;
}

.edit-des {
  cursor: pointer;
}

.center {
  height: 200px;
}
</style>
